import GlobalModal from "components/Modal/GlobalModal";

import { LocalPropertyContactFormProps } from "./types";
import styles from './contact.module.css';
import LocalAgentsContact from "components/Modal/LocalAgentsContact.tsx";

/**
  ModalContactForm
  This component does not manage its own state, that needs to happen in the parent component.
  @param id string.
  @param form array, describes the structure of the form and supplies the state to each element.
  @param modal ? settings for the modal
  @param Header ? component to show above the form
  @param Footer ? component to show below the form
*/
const LocalAgentsModal = (contactFormProps: LocalPropertyContactFormProps) => {
  const { isOpen, closeModal } = contactFormProps.modal;
  const { user, property, agentList } = contactFormProps;
  let newClasses = {
    portalclassname: "ContactFormPortal",
    overlayclassname: "ContactForm__Overlay",
    className: `${styles.ContactForm__Content} ${styles.Property_contact}`,
    bodyopenclassname: "ContactForm__Body--open",
    htmlopenclassname: "ContactForm__Html--open",
  };

  if (!isOpen) return null;
  return (
    <GlobalModal
      isOpen={isOpen}
      modalClasses={newClasses}
      close={closeModal} id={""}      >
      <button className={styles.CloseModal} onClick={closeModal}>
        <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/cross-grey-2.svg`} alt="Close Modal" />
      </button>

      <LocalAgentsContact user={user} closeModal={closeModal} title="Contact Local Experts" property={property}
        agentList={agentList} subTitle={""} />
    </GlobalModal>
  );
};

export default LocalAgentsModal;
